import React from 'react'
import { FieldRenderProps } from 'react-final-form'
import { SelectData, Html } from './type'
import { Select as StyledSelect, FieldIcon } from './styles'
import Icon from '../../Icon'

interface Props extends FieldRenderProps<string, HTMLSelectElement> {
  id: string
  data: SelectData
  html: Html
}

const Select: React.FC<Props> = ({ id, input, html, data}) => (
  <>
    {data.icon && (
      <FieldIcon>
        <Icon
          name={data.icon}
        />
      </FieldIcon>
    )}

    <StyledSelect
      id={id}
      {...input}
      {...html}
    >
      {data.options.map(option => (
        <option
          key={option.value}
          value={option.value}
        >
          {option.label}
        </option>
      ))}
    </StyledSelect>

    <span></span>
  </>
)

export default Select
